import { FC, ReactElement, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { PayrollPeriod } from '../../../@paco/entities/PayrollPeriod/PayrollPeriod'
import { TrackFormData } from '../../../@paco/entities/Track/Track'
import { useTypedDispatch, useTypedSelector } from '../../../@paco/redux/store'
import { setToast } from '../../../@paco/redux/toasts/toastsReducer'
import { editTrack } from '../../../@paco/redux/tracks/tracksActions'
import { setError } from '../../../@paco/redux/tracks/tracksReducer'
import { ToastType } from '../../../@paco/types'

import CompletePeriodOpenTracksContainer from '../../../containers/@pz/CompletePeriodOpenTracksContainer/CompletePeriodOpenTracksContainer'
import { TrackViewModel } from '../../../models'
import { fetchOpenTracks } from '../../../redux/@toolkit/@tracks/openTracks/openTracksActions'
import { Reducers } from '../../../redux/reducers'

interface ConnectedCompletePeriodOpenTracksProps {
    activePeriod?: PayrollPeriod;
    className?: string;
}

const ConnectedCompletePeriodOpenTracks: FC<ConnectedCompletePeriodOpenTracksProps> = ({
    activePeriod,
    className,
}): ReactElement => {
    const dispatch = useTypedDispatch()
    const { permissions, user } = useTypedSelector(state => state.authenticatedUserReducer)
    const { payrollPeriods } = useTypedSelector(state => state.pacoPayrollPeriodsReducer)
    const { settings } = useTypedSelector(state => state.pacoSettingsReducer)
    const openTracks = useSelector<Reducers, TrackViewModel[]>(state => state.openTracksReducer.openTracks)
    const isLoading = useSelector<Reducers, boolean>(state => state.openTracksReducer.isLoading)
    const { isLoading: isTracksLoading, error: tracksError } = useTypedSelector(state => state.pacoTracksReducer)

    const handleSubmitTrack = async (
        trackId: string,
        departmentId: string,
        formData: TrackFormData,
        accepted?: boolean,
        endedOpenTrackFromManager?: boolean,
    ): Promise<void> => {
        if (activePeriod) {
            await dispatch(editTrack(trackId, departmentId, formData, undefined, accepted, endedOpenTrackFromManager))
            await dispatch(fetchOpenTracks(activePeriod))
        }
    }

    useEffect(() => {
        if (tracksError) {
            dispatch(setToast({
                text: tracksError,
                type: ToastType.fail,
                shouldFadeOutAutomatically: false,
            }))
            dispatch(setError(''))
        }
    }, [tracksError])

    return (
        <CompletePeriodOpenTracksContainer
            isLoading={isLoading || isTracksLoading}
            payrollPeriods={payrollPeriods}
            permissions={permissions}
            currentUser={user}
            settings={settings}
            openTracks={openTracks}
            onSubmitTrack={handleSubmitTrack}
            className={className}
        />
    )
}

export default ConnectedCompletePeriodOpenTracks
